import React from 'react';
import { Box, Button } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { familyMembersOf, firstOpenLanguageMarket, languageVersionMemberLabel } from '../languageVersionHelpers';
import { COPY } from '../presentationCopy';
import { PresentationRecord } from '../types';

interface LanguageVersionBarProps {
  deck: PresentationRecord;
  canCreate: boolean;
  canEdit: boolean;
  onSwitch: (id: string) => void;
  onCreate: () => void;
  onLeave: () => void;
}

const LanguageVersionBar: React.FC<LanguageVersionBarProps> = ({
  deck, canCreate, canEdit, onSwitch, onCreate, onLeave,
}) => {
  const members = familyMembersOf(deck);
  const inGroup = Boolean(deck.familyId && (deck.familyMembers?.length || 0) > 1);
  const canAdd = canCreate && Boolean(firstOpenLanguageMarket(members));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0, flexShrink: 1 }}>
      {inGroup && members.map((member) => {
        const current = member._id === deck._id;
        return (
          <Button
            key={member._id}
            size="small"
            title={COPY.switchLanguageVersion}
            onClick={() => { if (!current) onSwitch(member._id); }}
            sx={{
              minWidth: 0,
              px: 1,
              minHeight: 28,
              textTransform: 'none',
              fontFamily: TYPE.ui,
              fontSize: 12,
              fontWeight: current ? 650 : 500,
              color: current ? PRES.white : PRES.textPrimary,
              bgcolor: current ? PRES.navy : PRES.white,
              border: `1px solid ${current ? PRES.navy : PRES.borderSubtle}`,
              '&:hover': {
                bgcolor: current ? PRES.navyDeep : PRES.surfaceSunken,
                borderColor: PRES.borderStrong,
              },
            }}
          >
            {languageVersionMemberLabel(member, members)}
          </Button>
        );
      })}
      {canAdd && (
        <Button
          size="small"
          onClick={onCreate}
          sx={{
            minHeight: 28,
            textTransform: 'none',
            color: PRES.interactive,
            border: `1px solid ${PRES.borderSubtle}`,
            bgcolor: PRES.white,
            px: 1,
          }}
        >
          {COPY.createLanguageVersion}
        </Button>
      )}
      {inGroup && canEdit && (
        <Button
          size="small"
          onClick={onLeave}
          sx={{
            minHeight: 28,
            textTransform: 'none',
            color: PRES.textSecondary,
            px: 1,
          }}
        >
          {COPY.leaveLanguageGroup}
        </Button>
      )}
    </Box>
  );
};

export default LanguageVersionBar;
